module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integrator-code-box",
    on: {
      "click": _vm.selectAll
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.texts["selectHint"]))]), _vm._v(" "), _c('div', {
    staticClass: "box-shadow"
  }, [_c('pre', [_c('code', {
    ref: "code"
  }, [_vm._v(_vm._s(_vm.code))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f6b0fe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/questions/tools/integrator/code_box.vue
// module id = 212
// module chunks = 0 8 17